/**
 * Created by BFR on 07/09/2015.
 */
define('adminLisDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'adminLisDetailsView',
  'emptyView',
  'lisDetailTabController',
  'adminLisAnaController',
  'adminLisAserieController',
  'adminLisSmpMatController',
  'adminLisDetailsController',
  'rolesMixin',
  'settings',
  'adminLisTabs',
  'entities/lis'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  lisDetailTabController,
  lisAnaTabController,
  lisAserieTabController,
  lisSmpMatTabController
) {
  'use strict';

  var LissDetailsController = {
    fetchLis: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showLis(data);
      } else {
        this.model = App.request('lis:model', {secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showLis(data);
          }
        });
      }
    },

    showLis: function(data) {
      var view = new View({model: this.model, data: data});

      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);

      this.displayTabs(data);

      view.listenTo(view, 'click:tab', _.bind(this.onTabClick, this));
      view.listenTo(App, 'lis:header:rerender', _.bind(this.onHeaderChange, this));
    },

    onHeaderChange: function (lis) {
      this.view.onHeaderChange(lis);
    },

    displayTabs: function(data) {
      for (var region in this.view.regions) {
        if (App.regions.getRegion('main') && App.regions.getRegion('main').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content') &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region)) {
          var currentViewRegion = App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region).currentView;
          if(currentViewRegion) {
            currentViewRegion.destroy();
          }
        }
      }

      if (data.tab) {
        switch (data.tab.name) {
          case 'lisana':
            lisAnaTabController.showLisAnaList(data);
            break;
          case 'lisaserie':
            lisAserieTabController.showLisAserieList(data);
            break;
          case 'lissmpmat':
            lisSmpMatTabController.showLisSmpMatList(data);
            break;
          default:
            lisDetailTabController.showTab(data);
            break;
        }
      } else {
        lisDetailTabController.showTab(data);
      }

      data.model = this.model;
      this.tab = data.tab;
    },

    onTabClick: function(tab) {
      if (this.data.tab !== tab || this.data.secId) {
        this.data.tab = tab;
        this.data.secId = null;

        this.displayTabs(this.data);
        App.navigate('admin/lis/' + this.model.get('secId') + '/' + tab.name);
      }
    }
  };

  module.exports = LissDetailsController;
});
